import { z } from 'zod';
import { DesignerSubscription } from './Subscription';

export enum FeatureKey {
    INVITE_EDITOR_COLLABORATOR = 'INVITE_EDITOR_COLLABORATOR',
    TEAM_COMPONENT_LIBRARY = 'TEAM_COMPONENT_LIBRARY',
    UPLOAD_DIAGRAM_FILES = 'UPLOAD_DIAGRAM_FILES',
    UPLOAD_DESIGN_FILES = 'UPLOAD_DESIGN_FILES',
    EXPORT_DIAGRAM_IMAGE_WITHOUT_WATERMARK = 'EXPORT_DIAGRAM_IMAGE_WITHOUT_WATERMARK',
    ADD_TEAM_MEMBERS = 'ADD_TEAM_MEMBERS',
    LINK_PRODUCT = 'LINK_PRODUCT',
    RUN_SIMULATIONS = 'RUN_SIMULATIONS',
    ARTIFICIAL_INTELLIGENCE = 'ARTIFICIAL_INTELLIGENCE',
    TECHNICAL_SUPPORT = 'TECHNICAL_SUPPORT',
}

export const FeatureAccess: Record<FeatureKey, DesignerSubscription[]> = {
    INVITE_EDITOR_COLLABORATOR: [DesignerSubscription.NONE, DesignerSubscription.STANDARD],
    TEAM_COMPONENT_LIBRARY: [DesignerSubscription.STANDARD],
    UPLOAD_DIAGRAM_FILES: [DesignerSubscription.NONE, DesignerSubscription.STANDARD],
    UPLOAD_DESIGN_FILES: [DesignerSubscription.NONE, DesignerSubscription.STANDARD],
    EXPORT_DIAGRAM_IMAGE_WITHOUT_WATERMARK: [DesignerSubscription.STANDARD],
    ADD_TEAM_MEMBERS: [DesignerSubscription.NONE, DesignerSubscription.STANDARD],
    RUN_SIMULATIONS: [DesignerSubscription.NONE, DesignerSubscription.STANDARD],
    LINK_PRODUCT: [DesignerSubscription.NONE, DesignerSubscription.STANDARD],
    ARTIFICIAL_INTELLIGENCE: [DesignerSubscription.NONE, DesignerSubscription.STANDARD],
    TECHNICAL_SUPPORT: [],
} as const;

export enum FeatureLimit {
    PROJECTS = 'PROJECTS',
    IMAGES = 'IMAGES',
    AI_REQUESTS = 'AI_REQUESTS',
    DESIGN_FILE_UPLOADS = 'DESIGN_FILE_UPLOADS',
}

export const FeatureLimitValidator = z.enum([
    FeatureLimit.PROJECTS,
    FeatureLimit.IMAGES,
    FeatureLimit.AI_REQUESTS,
    FeatureLimit.DESIGN_FILE_UPLOADS,
]);

export const FeatureLimits: Record<FeatureLimit, Record<DesignerSubscription, number>> = {
    [FeatureLimit.PROJECTS]: {
        [DesignerSubscription.NONE]: 3,
        [DesignerSubscription.STANDARD]: Infinity,
    },
    [FeatureLimit.IMAGES]: {
        [DesignerSubscription.NONE]: 1,
        [DesignerSubscription.STANDARD]: Infinity,
    },
    [FeatureLimit.AI_REQUESTS]: {
        [DesignerSubscription.NONE]: Infinity,
        [DesignerSubscription.STANDARD]: Infinity,
    },
    [FeatureLimit.DESIGN_FILE_UPLOADS]: {
        [DesignerSubscription.NONE]: Infinity,
        [DesignerSubscription.STANDARD]: Infinity,
    },
};

export const getSubscriptionForUnlimitedFeature = (feature: FeatureLimit) => {
    return Object.entries(FeatureLimits[feature]).find(([, limit]) => limit === Infinity)?.[0] as
        | DesignerSubscription
        | undefined;
};

export const subscriptionCanUseFeature = (subscription: DesignerSubscription, feature: FeatureKey) =>
    FeatureAccess[feature].includes(subscription);
